import { Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import WorkOrderForm from "./WorkOrderForm";
import DocumentUploadForm from "./RFIDetails/DocumentUploadForm";
import useRFIDetails from "../hooks/useRFIDetails";
import { useParams } from "react-router-dom";
import useDocumentController from "../hooks/useDocumentController";
import { useSelector } from "react-redux";
import PDFSignatureApp from "../pages/PDFSignatureApp";

const styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
    height: "80vh",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 0,
  },
};

const DCView = () => {
  const [collapsibleOpen, setCollapsibleOpen] = useState(false);
  const { rfinumber } = useParams();
  const { rfiDetails, loading, getRFIDetails } = useRFIDetails({
    rfi_id: rfinumber,
  });

  const { profile, loading: profileLoader } = useSelector(
    (state) => state.profile
  );

  const {
    formik,
    loading: fileLoader,
    file,
    deleteModal,
    startEsign,
    allDocSigned,
    handleFileChange,
    handleRemoveFile,
    handleCheckboxChange,
    handleDocumentStatusChange,
    isUploadDisabled,
    setDeleteModal,
    setFile,
    esignUrlLoading,
    loadPDF,
    error,
    pdfPages,
    currentPage,
    signatures,
    setCurrentPage,
    setSignatures,
    setError,
    setEsignUrlLoading,
    resetFcn,
    savePdfToDatabase,
    selectedDoc,
    pdfLoadingError,
  } = useDocumentController({
    docStatus: rfiDetails?.documents_status,
    getRFIDetails,
    role: profile?.role,
  });

  if (startEsign) {
    return (
      <>
        <PDFSignatureApp
          pdfPages={pdfPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          signatures={signatures}
          setSignatures={setSignatures}
          loading={esignUrlLoading}
          setLoading={setEsignUrlLoading}
          error={error}
          setError={setError}
          resetFcn={resetFcn}
          savePdfToDatabase={savePdfToDatabase}
          selectedDoc={selectedDoc}
          pdfLoadingError={pdfLoadingError}
          rfi_id={rfiDetails?.rfi_id}
        />
      </>
    );
  }

  return (
    <>
      {loading || fileLoader || profileLoader ? (
        <Box sx={styles.loader}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={styles.container}>
          <WorkOrderForm
            fields={rfiDetails}
            handleFieldChange={() => {}}
            handleSubmit={() => {
              /* handle submit here */
            }}
            editable={false}
            collapsibleOpen={collapsibleOpen}
            setCollapsibleOpen={setCollapsibleOpen}
          />
          <DocumentUploadForm
            formik={formik}
            handleFileChange={handleFileChange}
            handleRemoveFile={handleRemoveFile}
            handleCheckboxChange={handleCheckboxChange}
            handleDocumentStatusChange={handleDocumentStatusChange}
            isUploadDisabled={isUploadDisabled}
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            file={file}
            setFile={setFile}
            role={profile?.role}
            docStatus={rfiDetails?.documents_status}
            handleUrlSubmit={loadPDF}
            allDocSigned={allDocSigned}
            // role={"QC_Coordinator"}
          />
        </Box>
      )}
    </>
  );
};

export default DCView;
